import { GzEnumListWebComponent } from './component/GzEnumListWebComponent';
import { WEB_COMPONENT_GZ_ENUM_LIST } from '../../webcomponents.constants';

export { GzEnumListWebComponent };

window.customElements.define(WEB_COMPONENT_GZ_ENUM_LIST, GzEnumListWebComponent);
